/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type VerifyOnboardingHooksSetupSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type VerifyOnboardingHooksSetupRequest = {
  /**
   * Only return events with time_unix_nano greater than this value. Pass the previous response's latest_unix_nano to poll for new events. Stringified to preserve int64 precision.
   */
  sinceUnixNano?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type VerifyOnboardingHooksSetupSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const VerifyOnboardingHooksSetupSecurity$outboundSchema: z.ZodMiniType<
  VerifyOnboardingHooksSetupSecurity$Outbound,
  VerifyOnboardingHooksSetupSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function verifyOnboardingHooksSetupSecurityToJSON(
  verifyOnboardingHooksSetupSecurity: VerifyOnboardingHooksSetupSecurity,
): string {
  return JSON.stringify(
    VerifyOnboardingHooksSetupSecurity$outboundSchema.parse(
      verifyOnboardingHooksSetupSecurity,
    ),
  );
}

/** @internal */
export type VerifyOnboardingHooksSetupRequest$Outbound = {
  since_unix_nano?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const VerifyOnboardingHooksSetupRequest$outboundSchema: z.ZodMiniType<
  VerifyOnboardingHooksSetupRequest$Outbound,
  VerifyOnboardingHooksSetupRequest
> = z.pipe(
  z.object({
    sinceUnixNano: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sinceUnixNano: "since_unix_nano",
      gramSession: "Gram-Session",
    });
  }),
);

export function verifyOnboardingHooksSetupRequestToJSON(
  verifyOnboardingHooksSetupRequest: VerifyOnboardingHooksSetupRequest,
): string {
  return JSON.stringify(
    VerifyOnboardingHooksSetupRequest$outboundSchema.parse(
      verifyOnboardingHooksSetupRequest,
    ),
  );
}
